/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./radio.component";
var styles_UIRadioComponent = [];
var RenderType_UIRadioComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_UIRadioComponent, data: {} });
export { RenderType_UIRadioComponent as RenderType_UIRadioComponent };
export function View_UIRadioComponent_0(_l) { return i0.ɵvid(0, [i0.ɵncd(null, 0)], null, null); }
export function View_UIRadioComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "ui-radio", [], [[1, "disabled", 0], [2, "checked", null]], [[null, "click"], [null, "keydown.space"], [null, "keydown.spacebar"]], function (_v, en, $event) { var ad = true; if (("click" === en)) {
        var pd_0 = (i0.ɵnov(_v, 1)._onClick() !== false);
        ad = (pd_0 && ad);
    } if (("keydown.space" === en)) {
        var pd_1 = (i0.ɵnov(_v, 1)._onSpaceDown() !== false);
        ad = (pd_1 && ad);
    } if (("keydown.spacebar" === en)) {
        var pd_2 = (i0.ɵnov(_v, 1)._onSpacebarDown() !== false);
        ad = (pd_2 && ad);
    } return ad; }, View_UIRadioComponent_0, RenderType_UIRadioComponent)), i0.ɵdid(1, 49152, null, 0, i1.UIRadioComponent, [], null, null)], null, function (_ck, _v) { var currVal_0 = i0.ɵnov(_v, 1).disabled; var currVal_1 = i0.ɵnov(_v, 1).checked; _ck(_v, 0, 0, currVal_0, currVal_1); }); }
var UIRadioComponentNgFactory = i0.ɵccf("ui-radio", i1.UIRadioComponent, View_UIRadioComponent_Host_0, { disabled: "disabled", value: "value" }, { onCheckRadio: "onCheckRadio" }, ["*"]);
export { UIRadioComponentNgFactory as UIRadioComponentNgFactory };
